import { FC, PropsWithChildren } from 'react'

import { useAdvanceContentContext } from './hooks/useAdvanceContentContext'
import {
  StyledTakeAdvanceFooter,
  StyledTakeAdvanceFooterContainer,
} from './styles'

export const TakeAdvanceFooter: FC<PropsWithChildren> = ({ children }) => {
  const { contentOverflow } = useAdvanceContentContext()

  return (
    <StyledTakeAdvanceFooterContainer>
      <StyledTakeAdvanceFooter $showShadow={contentOverflow}>
        {children}
      </StyledTakeAdvanceFooter>
    </StyledTakeAdvanceFooterContainer>
  )
}
